import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 5E1C3338-5309-4631-A9A9-9D41E4CEC8A7
 * name information-slab-box
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-box.svg
 * tags
 * - Settings 
 */
export const InformationSlabBoxIcon = createSvgIcon(<><path d="M5 3H19C20.1 3 21 3.89 21 5V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 3.89 3.89 3 5 3M11 9H13V7H11V9M14 17V15H13V11H10V13H11V15H10V17H14Z" /></>, 'InformationSlabBoxIcon');
export default InformationSlabBoxIcon